/**
 * @fileoverview Form Submit Button Component
 *
 * Submit button with loading state and accessibility features.
 * Uses Tailwind CSS for styling.
 */

import { cn } from "@/lib/utils";

export interface FormSubmitProps {
	loading: boolean;
	disabled: boolean;
	submitText: string;
	loadingText: string;
}

export function FormSubmit({
	loading,
	disabled,
	submitText,
	loadingText,
}: FormSubmitProps) {
	return (
		<button
			type="submit"
			disabled={disabled}
			className={cn(
				"inline-flex items-center justify-center",
				"rounded-md px-8 py-3 text-sm font-medium",
				"bg-primary text-primary-foreground",
				"transition-colors",
				"cursor-pointer hover:bg-primary/90",
				"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
				"disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-primary",
			)}
			aria-live="polite"
			aria-busy={loading}
		>
			{loading ? (
				<>
					<svg
						className="mr-2 h-4 w-4 animate-spin"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						aria-hidden="true"
					>
						<circle
							className="opacity-25"
							cx="12"
							cy="12"
							r="10"
							stroke="currentColor"
							strokeWidth="4"
						/>
						<path
							className="opacity-75"
							fill="currentColor"
							d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
						/>
					</svg>
					<span>{loadingText}</span>
				</>
			) : (
				<span>{submitText}</span>
			)}
		</button>
	);
}
